import React, { forwardRef } from "react";
import { FillButton, GhostButton, OutlineButton } from "./styles";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "small" | "medium" | "large" | "giant";
  variant?: "fill" | "outline" | "ghost";
  icon?: React.ReactNode;
  children: React.ReactNode;
}

interface IObj {
  [key: string]: any;
}

const SIZES: IObj = {
  small: {
    "--fontSize": 14 / 16 + "rem",
    "--padding": "8px",
    "--iconSize": 16 / 16 + "rem",
  },
  medium: {
    "--fontSize": 16 / 16 + "rem",
    "--padding": "10px",
    "--iconSize": 16 / 16 + "rem",
  },
  large: {
    "--fontSize": 16 / 16 + "rem",
    "--padding": "14px",
    "--iconSize": 20 / 16 + "rem",
  },
  giant: {
    "--fontSize": 16 / 16 + "rem",
    "--padding": "22px",
    "--iconSize": 20 / 16 + "rem",
  },
};

const CustomButton = forwardRef<HTMLButtonElement, IProps>(
  ({ variant = "fill", size = "medium", icon, children, ...props }, ref) => {
    let Component;
    if (variant === "fill") Component = FillButton;
    else if (variant === "outline") Component = OutlineButton;
    else Component = GhostButton;

    return (
      <Component
        ref={ref}
        {...props}
        style={{ ...SIZES[size], ...props.style }}
      >
        <div>
          {icon}
        </div>
        {children}
      </Component>
    );
  }
);

export default CustomButton;
